export default __webpack_public_path__ + "static/media/rectarrow.58cb13e8.svg";